import axiosInstance from '../utils/axios.js';

export const Integrators = {
  /** Загружает компании: при переданном id/ids — компании интегратора(ов), без них — все доступные пользователю */
  async postIntegratorDealer({ from, count, id, ids, value }) {
    const body = {
      from: +from,
      count: +count,
      model: 'companies',
      value: value || ''
    };

    const dealerIds = ids?.length
      ? ids
      : (id != null && id !== '' ? [id] : []);

    if (dealerIds.length === 1) {
      body.dealer = { id: dealerIds[0] };
    } else if (dealerIds.length > 1) {
      body.dealers = dealerIds.map((dealerId) => ({ id: dealerId }));
    }

    const { data } = await axiosInstance.post(`/auth_admin_query`, body);
    return data;
  },

  async postIntegratorInfo({ from, count, value, sortField, sortDesc }) {
    const formData = {
      from: +from,
      count: +count,
      value: value || ''
    };
    if (sortDesc !== '') {
      formData.sortDesc = sortDesc;
      formData.sortField = sortField;
    }
    const { data } = await axiosInstance.post('dealers_admin_query', formData);
    return data;
  },
  async sideFilterIntegrators(formData) {
    const { data } = await axiosInstance.post('/dealers_admin_query', formData);
    return data;
  },
  async deleteIntegrator(id) {
    const { data } = await axiosInstance.delete(`/dealers/${id}`);

    return data;
  },

  async createIntegrators(formData) {
    const { data } = await axiosInstance.post('/dealers', {
      ...formData
    });

    return data;
  },

  async getIntegrator(id) {
    const { data } = await axiosInstance.get(`/dealers?ids=${id}`);

    return data;
  },

  async editIntegrators(params) {
    const { data } = await axiosInstance.put(`/dealers/${params.id}`, params);

    return data;
  },

  async addFile(id, file) {
    return await axiosInstance.post(`/dealers/${id}/public_offer_files`, file);
  },

  async updateIntegrators(formData) {
    try {
      const { data } = await axiosInstance.put('/dealers/' + formData.id, formData);
      return data;
    } catch (error) {
      return error;
    }
  },

  async unblockIntegrators(id, params) {
    try {
      return await axiosInstance.post(`/dealers/${id}/block_unblock`, {
        block: params,
      });
    } catch (error) {
      return error;
    }
  },
};
